// GENERATED CODE - DO NOT EDIT
export const CloseTransferReasonMap = {
    TRANSFER_COMPLETED: 'Transfer completed',
    TRANSFER_COMPLETED_WAS_NOT_LINKED_AT_INTAKE: 'Transfer completed, was not linked at intake',
    INCOMPLETE_OR_INACCURATE_PHARMACY_INFORMATION: 'Incomplete or inaccurate pharmacy information',
    NO_ELIGIBLE_PRESCRIPTIONS_ON_FILE: 'No eligible prescriptions on file',
    PHARMACY_DID_NOT_RESPOND: 'Pharmacy did not respond',
    PHARMACY_REQUIRES_PATIENT_TO_INITIATE: 'Pharmacy requires patient to initiate',
    PATIENT_CANCELED_REQUEST: 'Patient canceled request',
    OTHER: 'Other',
};
//# sourceMappingURL=close_transfer_reason.js.map